export default __webpack_public_path__ + "static/media/pin-box.a695b5bf.svg";